import { Badge as MuiBadge, } from '@mui/material';
export const Badge = MuiBadge;
